import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled, { css } from "styled-components";
import colors from "../common/colors";
import { ReactComponent as Incident } from "../common/icons/incident.svg";
import { loadGenericAlerts, getLatestGenericAlertForPage } from "./GenericAlert/redux";
import RichText from "./RichText";

const AlertsWrapper = styled.div`
  border-bottom: 1px solid ${colors.gray200};
  padding: 1rem;
  background: ${colors.white};
`;

const AlertBar = styled.div`
  width: 40px;
  color: ${colors.gray900};
  border-radius: 5px 0 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  background: #76d2b6; /* Rijksoverheid mint green */
`;

const AlertText = styled.div`
  border: 1px solid ${colors.gray300};
  border-left: 0;
  background: ${colors.gray100};
  padding: 10px;
  border-radius: 0 5px 5px 0;
  flex-grow: 1;
  p {
    margin: 0;
    padding: 0;
    line-height: normal;
  }
  a {
    color: ${colors.hemelsblauw};
  }
  /* Override default RichText sizes inside alerts to match WeatherAlert */
  #rich-text p {
    font-size: 16px;
  }
  #rich-text ol,
  #rich-text ul {
    font-size: 16px;
  }
`;

const AlertBox = styled.div`
  display: flex;
`;

const AlertIcon = styled(Incident)`
  width: 24px;
  height: 24px;
  margin: 0 auto;
`;


function GenericAlert({ pageContext }) {
  const dispatch = useDispatch();
  const item = useSelector(state => getLatestGenericAlertForPage(state, pageContext));

  useEffect(() => {
    dispatch(loadGenericAlerts());
  }, [dispatch]);

  if (!item) return null;

  return (
    <AlertsWrapper>
      <AlertBox>
        <AlertBar>
          <AlertIcon />
        </AlertBar>
        <AlertText>
          <RichText content={item.message} />
        </AlertText>
      </AlertBox>
    </AlertsWrapper>
  );
}

export default GenericAlert;
